<template>
  <v-layout wrap class="container px-2 py-0">
    <driver-navigation />
    <router-view/>
  </v-layout>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import DriverNavigation from '@/components/driver/DriverNavigation.vue';

export default {
  name: 'DriverPage',
  components: {
    DriverNavigation,
  },
  async created() {
    await this.fetchDriverName({ id: this.$route.params.driverId });
  },
  destroyed() {
    this.setDriverName('');
  },
  methods: {
    ...mapActions({
      fetchDriverName: 'driver/fetchDriverName',
    }),
    ...mapMutations({
      setDriverName: 'driver/setDriverName',
    }),
  },
};
</script>

<style lang="scss" scoped>
</style>
